import { BaseAPIClient } from "./baseApi";

const POST = "POST";
const GET = "GET";
const PUT = "PUT";
const DELETE = "DELETE";

export class PitchApi extends BaseAPIClient {
  validateEmail(email) {
    return this.call("/check-email", GET, email);
  }

  signIn(credentials) {
    return this.call("/sign-in", POST, credentials);
  }

  signUp(customerData) {
    return this.call("/sign-up", POST, customerData);
  }

  requestRecoverPassword(email) {
    return this.call("/recover", POST, { email });
  }

  validateOtp(otp) {
    return this.call(`/valid/${otp}`, GET);
  }

  updatePassword(data) {
    return this.call("/password", POST, data);
  }

  activateAccount(id) {
    return this.call(`/validate-email/${id}`, GET);
  }

  showProfile() {
    return this.call("/profile", GET);
  }

  removerDisponibilidade(id) {
    return this.call(`/profile/update/${id}`, DELETE);
  }

  updateProfile(data) {
    return this.call("/profile", PUT, data);
  }

  getPartnerPlans() {
    return this.call("/plans", GET);
  }

  createPartnerPlan(data) {
    return this.call("/plans", POST, data);
  }

  getNotifications(page) {
    return this.call(`/notifications?page=${page}&size=10`, GET);
  }

  readNotification(id) {
    return this.call(`/notifications/${id}`, PUT);
  }

  getStudyGroups() {
    return this.call("/groups", GET);
  }

  getOneStudyGroups(id) {
    return this.call("/groups/" + id, GET);
  }

  udpateRequest(id, data) {
    return this.call(`/groups/${id}`, PUT, data);
  }

  listCourseContent() {
    return this.call("/course", GET);
  }

  getCourseById(id) {
    return this.call(`/course/${id}`, GET);
  }

  getCourseContent(module, id) {
    return this.call(`/course/${module}/${id}`, GET);
  }

  calendar() {
    return this.call(`/calendar`, GET);
  }

  postergate(id, data) {
    return this.call(`/calendar/events/${id}`, PUT, data);
  }

  cancelarAula(id, motivo) {
    return this.call(`/calendar/events/${id}/cancel`, PUT, motivo);
  }

  adiarParaProxima(id, data) {
    return this.call(`/calendar/events/${id}/next`, PUT, { data });
  }

  getClassContentByLevel(level) {
    return this.call(`/course/by-level/`, POST, { level });
  }

  rearrange(eventId, classId) {
    return this.call(`/calendar/events/${eventId}/${classId}/rearrange`);
  }

  confirmClass(eventId) {
    return this.call(`/calendar/events/confirm/${eventId}`, PUT);
  }

  vote(id, option) {
    return this.call(`/calendar/vote/${id}`, POST, { agreed: option });
  }
}

const api = new PitchApi(process.env.VUE_APP_PITCH_API_PARTNER);

export default api;
